import { Moment } from 'moment';
import { UserSummary } from 'src/app/modules/account/modules/user/api/entity/userSummary.model';
import { LovValue } from 'src/app/modules/common/lov/lov-value/api/model/LovValue.model';
import { WithPermissionModel } from '../../../../../common/permission/api/entity/withPermission.model';
import {LovValueSummary} from '../../../../../common/lov/lov-value/api/model/lovValueSummary.model';

export class TreatmentFeedbackSummaryModel extends WithPermissionModel {
    date: Moment;
    patientFeedback: LovValueSummary;
    userFeedback: LovValueSummary;
    responsible: UserSummary;
    comment: string;
    id: number;
}

